const generateFormName = (formName = "", currentHref = "/") => {
  return `${currentHref.replace(/\//gi, "-")}-${formName}`;
};

export default generateFormName;
